<template>
  <ancestryline-modal title="forms.type-service.card-title-information" id="modal-type-service-filters" :close="true" @close="close" :loading="false">
    <form @submit.prevent="applyFilter">
      <card :header="$t('forms.type-service.card-title-information')" class="p-col-12" >
        <coff-input-text v-model="filters.name" label="forms.type-service.name" class="p-col-12 p-md-6 p-lg-6" />
        <coff-input-radio v-model="filters.isActive" @update="forceUpdateField('isActive', $event)" :options="options" label="forms.type-service.isActive" class="p-col-12 p-md-6 p-lg-6" />
      </card>

    </form>

    <template #footer>
      <div class="p-col-12">
        <Button :label="$t('btn.clear')" @click.prevent="clearFilter" class="p-button-secondary p-mr-auto"/>
        <Button :label="$t('btn.filter')" @click.prevent="applyFilter" class="float-right p-button-primary"/>
      </div>
    </template>

  </ancestryline-modal>
</template>

<script>
import DialogService from "@/business/ModalBusiness";

export default {
  name: "ModalTypeServiceFilter",

  props: {
    filters: {},
  },

  data() {
    return {
      options: [
        {value: true, label: 'field.default.yes'},
        {value: false, label: 'field.default.no'}
      ],
    }
  },

  methods:{

    forceUpdateField(field, value){
      this.$set(this.filters, field, value);
    },

    close(){
      DialogService.closeModal();
    },

    clearFilter(){
      this.filters = {name: null, isActive: null};
    },

    applyFilter(){
      DialogService.closeModal(this.filters);
    },

  },

}
</script>

<style scoped>

</style>